import { UserRole } from '../enums/userRole';

export class User {
    public id: string;
    public name: string;
    public email: string;
    public companyId: string;
    public roles: UserRole[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.email = json.email;
            this.roles = json.roles;
            this.companyId = json.companyId;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/domain/models/user.ts